import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoConsultaImpedimentos({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'consultaimpedimentos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacaoConsultaImpedimentos({ payload }) {
  try {
    const { imab_codigo, params } = payload;

    yield call(api.delete, `consultaimpedimentos/${imab_codigo}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaoconsultaimpedimentos, params } = payload;

    yield call(api.post, 'consultaimpedimentos', operacaoconsultaimpedimentos);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/consultaimpedimentos');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { imab_codigo } = payload;

    const { data } = yield call(api.get, `consultaimpedimentos/${imab_codigo}`);

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaoconsultaimpedimentos, params } = payload;

    yield call(api.put, 'consultaimpedimentos', operacaoconsultaimpedimentos);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/consultaimpedimentos');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'consultaimpedimentos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaoconsultaimpedimentos/CONSULTAIMPEDIMENTOS_IN_REQUEST',
    requestOperacaoConsultaImpedimentos
  ),
  takeLatest(
    '@operacaoconsultaimpedimentos/DELETE_CONSULTAIMPEDIMENTOS',
    deleteOperacaoConsultaImpedimentos
  ),
  takeLatest(
    '@operacaoconsultaimpedimentos/SUCCESS_REMOVE',
    requestOperacaoConsultaImpedimentos
  ),
  takeLatest('@operacaoconsultaimpedimentos/STORE_CONSULTAIMPEDIMENTOS', store),
  takeLatest('@operacaoconsultaimpedimentos/FIND_CONSULTAIMPEDIMENTOS', find),
  takeLatest(
    '@operacaoconsultaimpedimentos/UPDATE_CONSULTAIMPEDIMENTOS',
    update
  ),
  takeLatest('@operacaoconsultaimpedimentos/RECORD_FILTERING', applyedFilters),
]);
